import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzContentComponent, NzFooterComponent, NzHeaderComponent, NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NzElementPatchDirective } from 'ng-zorro-antd/core/element-patch';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzSegmentedModule } from 'ng-zorro-antd/segmented';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { cs_CZ, provideNzI18n, NZ_DATE_CONFIG } from 'ng-zorro-antd/i18n';

@NgModule({
  imports: [
    CommonModule,
    NzButtonModule,
    NzIconModule,
    NzLayoutModule,
    NzMenuModule,
    NzFooterComponent,
    NzContentComponent,
    NzHeaderComponent,
    NzDividerModule,
    NzTooltipModule,
    NzElementPatchDirective,
    NzInputModule,
    NzFormModule,
    NzCollapseModule,
    NzBadgeModule,
    NzSegmentedModule,
    NzSwitchModule,
    NzDropDownModule,
    NzProgressModule,
    NzDatePickerModule,
    NzSpinModule,
    NzCardModule,
    NzGridModule,
    NzModalModule,
    NzRadioModule,
    NzCheckboxModule,
    NzSliderModule,
    NzUploadModule,
    NzSelectModule,
    NzPaginationModule,
  ],
  exports: [
    NzButtonModule,
    NzIconModule,
    NzLayoutModule,
    NzMenuModule,
    NzFooterComponent,
    NzContentComponent,
    NzHeaderComponent,
    NzDividerModule,
    NzTooltipModule,
    NzElementPatchDirective,
    NzInputModule,
    NzFormModule,
    NzCollapseModule,
    NzBadgeModule,
    NzSegmentedModule,
    NzSwitchModule,
    NzDropDownModule,
    NzProgressModule,
    NzDatePickerModule,
    NzSpinModule,
    NzCardModule,
    NzGridModule,
    NzTabsModule,
    NzModalModule,
    NzRadioModule,
    NzCheckboxModule,
    NzSliderModule,
    NzUploadModule,
    NzSelectModule,
    NzPaginationModule,
  ],
  providers: [
    provideNzI18n(cs_CZ),
    { provide: NZ_DATE_CONFIG, useValue: { firstDayOfWeek: 1 } }
  ]
})
export class ZorroModule {}
